import React from 'react';
import ReactDOM from 'react-dom/client';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { enGB } from 'date-fns/locale/en-GB';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Every calendar (admin + supplier) starts on Monday and ends on Sunday.
// en-GB carries weekStartsOn: 1; setting it as the default locale applies it
// to every react-datepicker instance app-wide without per-picker props.
registerLocale('en-GB', enGB);
setDefaultLocale('en-GB');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
